var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
// How far outside the viewport an image starts loading, so it is there by the time it scrolls in.
const NEAR_VIEWPORT = '400px';
// Shows the placeholder until the image has loaded. The image loads once the placeholder comes near
// the viewport, as loading="lazy" would, unless `loading` is "eager": a page of photos fetches only
// the ones that can be seen. The hidden loader can't take loading="lazy" itself, since a hidden image
// never reaches the viewport.
const Img = (_a) => {
    var { src, srcSet, sizes, placeholder, alt, onClick, style, loading } = _a, rest = __rest(_a, ["src", "srcSet", "sizes", "placeholder", "alt", "onClick", "style", "loading"]);
    const [loadedSrc, setLoadedSrc] = useState(null);
    const [near, setNear] = useState(loading === 'eager');
    const shown = useRef(null);
    const loaded = loadedSrc === src;
    useEffect(() => {
        const image = shown.current;
        if (near || image === null)
            return;
        if (typeof IntersectionObserver === 'undefined') {
            setNear(true);
            return;
        }
        const observer = new IntersectionObserver((entries) => {
            if (entries.some(e => e.isIntersecting)) {
                setNear(true);
                observer.disconnect();
            }
        }, { rootMargin: NEAR_VIEWPORT });
        observer.observe(image);
        return () => observer.disconnect();
    }, [near]);
    const displaySrc = loaded ? src : placeholder;
    const gatedOnClick = loaded ? onClick : undefined;
    const effectiveStyle = onClick && !gatedOnClick ? Object.assign(Object.assign({}, style), { cursor: 'default' }) : style;
    return (_jsxs(_Fragment, { children: [_jsx("img", Object.assign({}, rest, { ref: shown, src: displaySrc, srcSet: loaded ? srcSet : undefined, sizes: loaded ? sizes : undefined, 
                // A decorative image (alt="") stays silent while it loads too.
                alt: loaded || alt === '' ? alt : (alt ? `Loading ${alt}` : 'Loading image'), onClick: gatedOnClick, style: effectiveStyle })), !loaded && near && (
            // Loads the candidate srcSet picks, so the shown image comes from the cache, not a second fetch.
            _jsx("img", { src: src, srcSet: srcSet, sizes: sizes, alt: "", "aria-hidden": "true", style: { display: 'none' }, onLoad: () => setLoadedSrc(src), onError: () => setLoadedSrc(null) }))] }));
};
export default Img;
